import request from './request'

export function certPageApi(params) {
  return request.get('/api/admin/certificates', { params })
}

export function certGetApi(id) {
  return request.get(`/api/admin/certificates/${id}`)
}

export function certCreateApi(data) {
  return request.post('/api/admin/certificates', data)
}

export function certUpdateApi(id, data) {
  return request.put(`/api/admin/certificates/${id}`, data)
}

export function certDeleteApi(id) {
  return request.delete(`/api/admin/certificates/${id}`)
}

export function certUpdateScanCountApi(id, data) {
  return request.put(`/api/admin/certificates/${id}/scan-count`, data)
}

/** 按证书 ID 获取 ZXing 生成的二维码 */
export function certQrCodeApi(id, params) {
  return request.get(`/api/admin/certificates/${id}/qr-code`, { params })
}

/** 按查询码获取 ZXing 生成的二维码（新建后尚无 id 时使用） */
export function certQrCodeByQueryApi(queryCode, params) {
  return request.get('/api/admin/certificates/qr-code', {
    params: { queryCode, ...params }
  })
}

/** 导出证书 Excel（当前筛选条件，最多 5 万条）；config 可传 onDownloadProgress 等 */
export function certExportApi(params, config = {}) {
  return request.get('/api/admin/certificates/export', {
    params,
    responseType: 'blob',
    timeout: 300000,
    ...config
  })
}

/** 批量删除证书（ids 最多 200 条） */
export function certBatchDeleteApi(ids) {
  return request.post('/api/admin/certificates/batch-delete', { ids })
}

/** 批量下载二维码 ZIP（ids 最多 200 条） */
export function certBatchQrDownloadApi(ids, config = {}) {
  return request.post(
    '/api/admin/certificates/qr-code/batch-download',
    { ids },
    {
      responseType: 'blob',
      timeout: 300000,
      ...config
    }
  )
}

/** 按当前筛选条件下载全部二维码 ZIP（最多 5000 条） */
export function certDownloadAllQrApi(params, config = {}) {
  return request.get('/api/admin/certificates/qr-code/download-all', {
    params,
    responseType: 'blob',
    timeout: 300000,
    ...config
  })
}

/** 下载批量导入模板 */
export function certImportTemplateApi() {
  return request.get('/api/admin/certificates/import-template', {
    responseType: 'blob',
    timeout: 60000
  })
}

/** 上传 Excel 预览（复检） */
export function certImportPreviewApi(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request.post('/api/admin/certificates/import/preview', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 300000
  })
}

/** 复检确认后批量新增 */
export function certImportConfirmApi(data) {
  return request.post('/api/admin/certificates/import/confirm', data, {
    timeout: 300000
  })
}
